import {atom} from 'recoil';
import {TicketGroupT} from '../external_usage';

export type GroupsStateT = {
  groups?: TicketGroupT[];
  loading: boolean;
};

export const groupsState = atom<GroupsStateT>({
  key: 'groups-state',
  default: {
    loading: true,
  },
});

export type CurrentGroupsStateT = {
  group?: TicketGroupT;
  loading: boolean;
};

export const currentGroupState = atom<CurrentGroupsStateT>({
  key: 'group-state',
  default: {
    loading: true,
  },
});
